<div class="report-container">
  <powerbi-report [embedConfig]="powerBiReportVm.reportConfig" [cssClassName]="powerBiReportVm.cssClassName" [phasedEmbedding]="powerBiReportVm.phasedEmbedding" [eventHandlers]="eventHandlersMap">
  </powerbi-report>
</div>
